(function($) {

	'use strict';

	var init = function() {
		initHeaderNav();
        $( window ).resize(function(){
            initNavResize();
        });
        
        $( window ).resize();
	};

	var initHeaderNav = function() {
        //Burger menu
        $(".button-menu").on("click", function (e) {
            $(this).next('nav').toggleClass('open');
            if($(this).hasClass('active')){
                $('.button-menu').removeClass("active");
                $('.contain-overflow').attr('style','');
                $('.nav-main-menu').slideUp(100);
            }
            else{
                $(this).addClass("active");
                $('.contain-overflow').css({'overflow':'hidden', 'position':'fixed', 'width':'100%'});
                $('.nav-main-menu').slideDown(200);
            }
        });
	};
    
    var initNavResize = function(){
        if(window.matchMedia("(min-width: 1100px)").matches){
            $('.nav-main-menu').attr('style', '');
            $('.burger-menu').removeClass('active');
            $('#main-menu .sub-menu').attr('style', '');
            $('.contain-overflow').attr('style','');
        }
        else{
            
        }
    };

	$(document).ready(function() {
		init();
	});

})(jQuery);
